import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  const mainCategories = categories.slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            分类精选
          </h2>
          <p className="text-sm text-foreground-500">探索你喜爱的漫画类型，发现更多精彩作品</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {mainCategories.map((cat) => {
            const colorClasses = cat.color === 'primary'
              ? 'bg-primary-50 text-primary-700 border-primary-200 hover:bg-primary-100'
              : cat.color === 'accent'
              ? 'bg-accent-50 text-accent-700 border-accent-200 hover:bg-accent-100'
              : 'bg-secondary-50 text-secondary-700 border-secondary-200 hover:bg-secondary-100';

            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg border transition-all duration-300 cursor-pointer ${colorClasses}`}
              >
                <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full transition-transform duration-300 group-hover:scale-110 ${
                  cat.color === 'primary' ? 'bg-primary-100' : cat.color === 'accent' ? 'bg-accent-100' : 'bg-secondary-100'
                }`}>
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </div>
                <span className="text-sm md:text-base font-semibold whitespace-nowrap">{cat.name}</span>
                <span className="text-xs opacity-60">{cat.count}部</span>
              </Link>
            );
          })}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 text-sm font-medium text-foreground-600 hover:text-primary-500 transition-colors duration-200"
          >
            查看全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}